class collectionGridItem extends HTMLElement {
    constructor() {
        super();

        this.mainCollection = document.querySelector(".main-collection");
        this.desktopPosition = parseInt(this.dataset.desktopPosition);
        this.mobilePosition = parseInt(this.dataset.mobilePosition);

        this.init();

        document.addEventListener("collection-grid-item:init", () => {
            this.init();
        });
    };

    init() {
        this.appendGridItem();
    };

    appendGridItem() {
        if(document.documentElement.clientWidth > 990) {
            const targetProductItem = this.mainCollection.querySelector(`#collectionGrid .grid-product:nth-child(${this.desktopPosition})`);

            
            if(targetProductItem) {
                targetProductItem.insertAdjacentHTML("afterEnd", this.innerHTML)
            }else {
                this.mainCollection.querySelector("#collectionGrid").insertAdjacentHTML("beforeEnd", this.innerHTML)
            }
        }else {
            const targetProductItem = this.mainCollection.querySelector(`#collectionGrid .grid-product:nth-child(${this.mobilePosition})`);

            if(targetProductItem) {
                targetProductItem.insertAdjacentHTML("afterEnd",this.innerHTML)
            }else {
                this.mainCollection.querySelector("#collectionGrid").insertAdjacentHTML("beforeEnd", this.innerHTML)
            }
        }
    };
}
  
customElements.define('collection-grid-item', collectionGridItem);
  